<script lang="ts">
	import type { GridBlock } from '$models/Block/GridBlock';
	import { getWordPressImageSrcSet } from '$lib/images';
	import { sanitizeHtml } from '$lib/utils';

	// Component properties
	export let block: GridBlock;

	function getGridImageSizes(columns: number): string {
		if (columns === 2) {
			return '(min-width: 640px) 50vw, 100vw';
		}

		if (columns === 3) {
			return '(min-width: 640px) 33vw, 100vw';
		}

		return '(min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw';
	}
</script>

<div class="grid">
	{#if block.introText}
		<div class="grid-intro">
			{@html sanitizeHtml(block.introText)}
		</div>
	{/if}
	<div class="grid-container grid-container--count-{block.columns}">
		{#each block.items as item}
			<div class="grid-item">
				{#if item.image}
					<figure class="grid-item-image">
						<img
							src={item.image.url}
							srcset={getWordPressImageSrcSet(item.image)}
							sizes={getGridImageSizes(block.columns)}
							alt={item.image.alt}
							width={item.image.width}
							height={item.image.height}
							loading="lazy"
							decoding="async"
						/>
					</figure>
				{/if}
				<div class="grid-item-content">
					{#if item.title}
						<h3 class="grid-item-title">{@html item.title}</h3>
					{/if}
					{#if item.text}
						<div class="grid-item-text rich-text">
							{@html sanitizeHtml(item.text)}
						</div>
					{/if}
				</div>
			</div>
		{/each}
	</div>
</div>

<style lang="postcss">
	.grid {
		& {
			max-width: var(--container-small);
			margin: 0 auto;
		}
		&-intro {
			text-align: center;
			margin-bottom: var(--spacing-10);
		}

		&-container {
			display: grid;
			gap: var(--spacing-5);

			@media (--lg) {
				gap: var(--spacing-8);
			}

			&--count-2 {
				max-width: 800px;
				margin: 0 auto;
				@media (--sm) {
					grid-template-columns: repeat(2, 1fr);
				}
			}

			&--count-3 {
				@media (--sm) {
					grid-template-columns: repeat(3, 1fr);
				}
			}

			&--count-4 {
				@media (--sm) {
					grid-template-columns: repeat(2, 1fr);
				}

				@media (--lg) {
					grid-template-columns: repeat(4, 1fr);
				}
			}
		}

		&-item {
			display: flex;
			flex-direction: column;
			gap: var(--spacing-2);

			&-image {
				margin: 0 auto;

				&:not(:last-child) {
					margin-bottom: var(--spacing-4);
				}

				img {
					display: block;
					width: 100%;
					height: auto;
				}
			}

			&-content {
				flex: 1;
				text-align: center;
			}

			&-title {
				font-size: var(--font-size-3);

				&:not(:last-child) {
					margin-bottom: var(--spacing-3);
				}
			}

			&-text {
				margin-bottom: var(--spacing-4);
			}
		}
	}
</style>
